import React from "react";

const BrandLogo = ({ imageClassName = "h-9 w-auto" }) => (
  <span className="inline-flex shrink-0 flex-col items-center justify-center leading-none">
    <img src="/showmelive-logo.png" alt="ShowMeLive" className={imageClassName} />
    <span className="mt-0.5 text-[8px] font-black uppercase tracking-[0.32em] text-blue-400">
      Beta
    </span>
  </span>
);

export default BrandLogo;
